module.exports = __webpack_public_path__ + "img/Matschweg.5d3772c1.svg";